module.exports = __webpack_public_path__ + "static/daybreak-logo-470427e8f34dee962ae858eb568e7502.jpg";